import { MicrocertificateModel } from '@/models/microcertificates/microcertificate.model';

export interface MicrocertificateState {
  microcertificates?: MicrocertificateModel[];
  isGenerating?: boolean;
}

const state: MicrocertificateState = {
  microcertificates: [],
  isGenerating: false,
};

export default state;
